module.exports = __webpack_public_path__ + "img/phone-screen-jp.7df2ae2e.png";